import axios from "axios";
import { cityList } from "../api/shoppingData.js";
import Vue from 'vue';
import dayjs from 'dayjs';
//获取服务器日期
export async function getServerTimeAxios(resolve) {
  axios
    .get(location.origin + process.env.BASE_URL + '?t=' + new Date().getTime())
    .then(function (response) {
      if (response.status == 200) {
        resolve(new Date(response.headers.date));
      }
    })
    .catch(function (error) {
      console.log("获取服务器日期请求失败", error);
    });
}

//Get yyyy|MM|dd|HH|mm|ss
export function formatDateTime(time, format) {
  return dayjs(time).format(format);
}

export function getFileName() {
  return "HBE" + dayjs().format("YYYYMMDDHHmmssSSS");
}

// 时间加减 num 数值  oldDate 初始时间 时间格式 yyyy/MM/dd
export function dateChange(num, oldDate) {
  return dayjs(oldDate).add(num, 'day').format('YYYY-MM-DD');
}

export function getNights(checkOutAt, checkInAt) {
  return dayjs(checkOutAt).diff(dayjs(checkInAt), 'day');
}

//booking 到达时间
export function getArriveTime() {
  const times = [];
  for (let i = 16; i <= 23; i++) {
    times.push(dayjs().hour(i).minute(0).format("HH:mm"));
  }
  for (let i = 0; i <= 7; i++) {
    times.push(dayjs().hour(i).minute(0).format("HH:mm"));
  }
  return times;
}
// 房型特殊需求
export function getSpecialRoom() {
  return [
    { name: { en: "Smoking Room", "zh-CN": "吸烟房" }, value: 0 },
    { name: { en: "Non-smoking Room", "zh-CN": "无烟房" }, value: 1 },
  ];
}
// 房型特殊需求
export function getSpecialSabreRoom() {
  return [
    { name: { en: "SMK", "zh-CN": "吸烟房" }, value: 0 },
    { name: { en: "NSMK", "zh-CN": "无烟房" }, value: 1 },
  ];
}

// 床型特殊需求
export function getSpecialBed() {
  return [
    { name: { en: "Queen Bed", "zh-CN": "大床房" }, value: 0 },
    { name: { en: "Twin Beds", "zh-CN": "双床房" }, value: 1 },
  ];
}
export function getSpecialSabreBed() {
  return [
    { name: { en: "KING BED", "zh-CN": "大床房" }, value: 0 },
    { name: { en: "TWIN BEDS", "zh-CN": "双床房" }, value: 1 },
  ];
}

//从CRM、OBT跳转过来时隐藏页面元素
export function hideElement($this) {
  if ($this.$objBaseInfo.sourceType == "CRM") {
    if (document.getElementById("cwt_hotel_booking_search"))
      document.getElementById("cwt_hotel_booking_search").style.display =
        "none";
    //隐藏面包屑
    if (document.getElementsByClassName("el-breadcrumb").length > 0)
      document.getElementsByClassName("el-breadcrumb")[0].style.display =
        "none";
    //隐藏左侧菜单
    if ($this.$route.name == "orderList") {
      if (document.getElementsByClassName("el-aside").length > 0)
        document.getElementsByClassName("el-aside")[0].style.display = "none";
      if (document.getElementsByClassName("el-header").length > 0)
        document.getElementsByClassName("el-header")[0].style.display = "none";
    }
  } else if (
    $this.$objBaseInfo.sourceType == "OBT" &&
    $this.$route.name == "orderList"
  ) {
    //隐藏面包屑
    if (document.getElementsByClassName("el-breadcrumb").length > 0)
      document.getElementsByClassName("el-breadcrumb")[0].style.display =
        "none";
    //隐藏左侧菜单
    if (document.getElementsByClassName("el-aside").length > 0)
      document.getElementsByClassName("el-aside")[0].style.display = "none";
  }
}

function validateCreditcardnumber(inputNum) {
  let digit, flag, sum, _i, _len;
  flag = true;
  sum = 0;
  const digits = (inputNum + "").split("").reverse();
  for (_i = 0, _len = digits.length; _i < _len; _i++) {
    digit = digits[_i];
    digit = parseInt(digit, 10);
    if ((flag = !flag)) {
      digit *= 2;
    }
    if (digit > 9) {
      digit -= 9;
    }
    sum += digit;
  }
  return sum % 10 === 0;
}
//信用卡正则表达式
export function getCreditCard(cardNo) {
  let result = false;
  cardNo = cardNo.toString();

  const length = cardNo.length;
  if ((length > 13 && length < 17) || length === 19) {
    result = validateCreditcardnumber(cardNo);
  }
  return result;
}
export function getCreditType(code) {
  let type = "";
  switch (code) {
    case "AX": //美国运通
      type = "AX";
      break;
    case "CA": //万事达
      type = "MC";
      break;
    case "VI": // 维萨
      type = "VC";
      break;
    case "DC": //大来卡
      type = "dinersclub";
      break;
    case "JC": //JCB卡
      type = "jcb";
      break;
    case "DS": //发现卡
      type = "DC";
      break;
    case "UnionPay": //银联卡
      type = "UnionPay";
      break;
  }
  return type;
}
//行程单拦截校验
export function validateTrip($this, cityCode, checkInDate, checkOutDate) {
  checkInDate = formatDateTime(checkInDate, "YYYY-MM-DD");
  checkOutDate = formatDateTime(checkOutDate, "YYYY-MM-DD");
  if ($this.$objBaseInfo.ordApprovalType == 1 && !$this.$objBaseInfo.isOnlySearch) {
    //行程单逻辑
    //点判断是否在白名单
    var isWhiteList = false;
    if ($this.$objBaseInfo.nameListType === 1 && !$this.$objBaseInfo.tripOrderInfo) 
    {
      if($this.$objBaseInfo.nameListProduct == undefined || $this.$objBaseInfo.nameListProduct == '')
      {
        isWhiteList = true;
      }
      else if($this.$objBaseInfo.destinationType == "I" && $this.$objBaseInfo.nameListProduct.includes("InternationalHotel"))
      {
        isWhiteList = true;
      } 
      else if($this.$objBaseInfo.destinationType == "D" && $this.$objBaseInfo.nameListProduct.includes("DomesticHotel"))
      {
        isWhiteList = true;
      } 
    }

    if (isWhiteList) {
      //白名单人员
      return "";
    } else {
      let isExitTrip = true;
      if (
        $this.$objBaseInfo.tripOrderInfo == null ||
        $this.$objBaseInfo.tripOrderInfo == undefined
      ) {
        isExitTrip = false;
      }
      //判断强弱管控 是不是有行程单数据
      if ($this.$objBaseInfo.strongControl == 1 && isExitTrip) {
        //强管控
        //不在白名单 判断目的地是否正确
        const matchedList = $this.$objBaseInfo.tripOrderInfo.location.filter(
          location => location.locationCode.toString() === cityCode.toString()
        );
        //目的地与行程单目的地不一致
        if (matchedList.length === 0) {
          return $this.$t("SEARCH.CONFIRMDEST");
        }

        function isDateOutOfRange(date, checkOutEnd, checkInDateBegin) {
          return (
            new Date(date).getTime() > new Date(checkOutEnd).getTime() ||
            new Date(date).getTime() < new Date(checkInDateBegin).getTime()
          );
        }

        if (matchedList.length === 1) {
          const location = matchedList[0];
          const checkOutEnd = formatDateTime(location.checkOutEnd, "YYYY-MM-DD");
          const checkInDateBegin = formatDateTime(location.checkInDateBegin, "YYYY-MM-DD");
          const inDateValid = isDateOutOfRange(checkInDate, checkOutEnd, checkInDateBegin);
          const outDateValid = isDateOutOfRange(checkOutDate, checkOutEnd, checkInDateBegin);
          //入住时间需要在行程单入住时间范围之内
          if (inDateValid) {
            return $this.$t("SEARCH.CONFIRMRANGEIN", {
              inDate: checkInDateBegin,
              outDate: checkOutEnd,
            });
          }
          //离开时间需要在行程单离开时间范围之内
          if (outDateValid) {
            return $this.$t("SEARCH.CONFIRMRANGEOUT", {
              inDate: checkInDateBegin,
              outDate: checkOutEnd,
            });
          }
          return "";
        }

        // 多条，任意一条checkInDate或checkOutDate满足就返回
        const allMatch = matchedList.every(location => {
          const checkOutEnd = formatDateTime(location.checkOutEnd, "YYYY-MM-DD");
          const checkInDateBegin = formatDateTime(location.checkInDateBegin, "YYYY-MM-DD");
          const inDateValid = isDateOutOfRange(checkInDate, checkOutEnd, checkInDateBegin);
          const outDateValid = isDateOutOfRange(checkOutDate, checkOutEnd, checkInDateBegin);
          return inDateValid || outDateValid;
        });

        if (allMatch) {
          return $this.$t("SEARCH.INVALID_CHECKIN_OR_CHECKOUT_DATE");
        }
        return "";
      } else {
        //弱管控
        if (isExitTrip) {
          return "";
        } else {
          //未选择行程单
          return $this.$t("SEARCH.CONFIRMTRIP");
        }
      }
    }
  } else {
    return "";
  }
}

// 判断目的地是否一致
export function isLocation(locationList, cityCode) {
  for (const location of locationList) {
    if (location.locationCode.toString() == cityCode.toString()) {
      return true;
    }
  }
  return false;
}

//是否为中文字符串
export function isChinese(temp) {
  var re = /(^[\u4e00-\u9fa5\u3400-\u4DBF\u20000-\u2A6DF]{0,}$)/;
  if (re.test(temp)) return true;
  return false;
}

//是否为全英文字符串和空格(有且只有一个空格，例如 张三强，写成zhang sanqiang)
export function isEnglish(temp) {
  temp = temp.trim();
  if (temp.indexOf(" ") > 0) {
    temp = temp.replace(" ", "");
    var re = /^[A-Za-z]+$/;
    if (re.test(temp)) return true;
    return false;
  } else {
    return false;
  }
}

//是否为全英文字符串和 空格或者/
export function isEnglishAndOther(temp) {
  temp = temp.trim();
  if (temp.indexOf(" ") > 0) {
    temp = temp.replace(" ", "");
    let re = /^[A-Za-z]+$/;
    if (re.test(temp)) return true;
    return false;
  } else if (temp.indexOf("/") > 0 && temp.indexOf("/") != temp.length - 1) {
    temp = temp.replace("/", "");
    let re = /^[A-Za-z]+$/;
    if (re.test(temp)) return true;
    return false;
  } else {
    return false;
  }
}

//是否为全英文字符串和斜线
export function isEnglishAndOtherTwo(temp) {
  temp = temp.trim();
  if (temp.indexOf("/") > 0 && temp.indexOf("/") != temp.length - 1) {
    temp = temp.replace("/", "");
    var re = /^[A-Za-z]+$/;
    if (re.test(temp)) return true;
    return false;
  } else {
    return false;
  }
}

//通过cityCode 获取 cityName
export async function getCityInfoByCode(code) {
  return new Promise((resolve) => {
    let params = {
      params: {
        cityCode: code,
        isEnable: 1,
      },
    };
    cityList(params)
      .then((res) => {
        if (res.code === 200) {
          if (res.data.error.code != 0) {
            console.log(
              "城市信息请求失败, code:" + res.data.error.code,
              res.data.error.message
            );
            resolve(null);
          } else {
            res.data.list.length == 1
              ? resolve(res.data.list[0])
              : resolve(null);
          }
        } else {
          console.log("城市信息请求失败, code:" + res.code, res.message);
          resolve(null);
        }
      })
      .catch((err) => {
        console.log("城市信息请求异常：", err.objError);
        resolve(null);
      });
  });
  // for (const key of $this.$dictionaryData.cityList) {
  //   if (key.cityCode.toString() == code.toString()) {
  //     return key;
  //   }
  // }
  // return {};
}

//通过gaoDeCityCode 获取 cityName
export async function getCityInfoByGaoDeCode(code) {
  return new Promise((resolve) => {
    let params = {
      params: {
        gaoDeCityCode: code,
        isEnable: 1,
      },
    };
    cityList(params)
      .then((res) => {
        if (res.code === 200) {
          if (res.data.error.code != 0) {
            console.log(
              "城市信息请求失败, code:" + res.data.error.code,
              res.data.error.message
            );
            resolve(null);
          } else {
            res.data.list.length == 1
              ? resolve(res.data.list[0])
              : resolve(null);
          }
        } else {
          console.log("城市信息请求失败, code:" + res.code, res.message);
          resolve(null);
        }
      })
      .catch((err) => {
        console.log("城市信息请求异常：", err.objError);
        resolve(null);
      });
  });
}
//判断预订失败的code
export function codeIsCode(code) {
  const codeList = [10804, 10803, 10801, 10004, 10006, 10008, 10005, 10806];
  if (codeList.indexOf(code) > -1) {
    return true;
  } else {
    return false;
  }
}

//发卡银行
export function issuerBank() {
  return [
    { label: {"zh-CN": "ABC农业银行", en: "ABC"}, code: "ABC" },
    { label: {"zh-CN": "BOB北京银行", en: "BOB"}, code: "BOB" },
    { label: {"zh-CN": "BOC中国银行", en: "BOC"}, code: "BOC" },
    { label: {"zh-CN": "BOS上海银行", en: "BOS"}, code: "BOS" },
    { label: {"zh-CN": "CCB建设银行", en: "CCB"}, code: "CCB" },
    { label: {"zh-CN": "CEB广大银行", en: "CEB"}, code: "CEB" },
    { label: {"zh-CN": "CIB兴业银行", en: "CIB"}, code: "CIB" },
    { label: {"zh-CN": "CITI花旗银行", en: "CITI"}, code: "CITI" },
    { label: {"zh-CN": "CMB招商银行", en: "CMB"}, code: "CMB" },
    { label: {"zh-CN": "CMBC民生银行", en: "CMBC"}, code: "CMBC" },
    { label: {"zh-CN": "COMM交通银行", en: "COMM"}, code: "COMM" },
    { label: {"zh-CN": "ECITIC中信银行", en: "ECITIC"}, code: "ECITIC" },
    { label: {"zh-CN": "GDB广东发展银行", en: "GDB"}, code: "GDB" },
    { label: {"zh-CN": "HXB华夏银行", en: "HXB"}, code: "HXB" },
    { label: {"zh-CN": "ICBC工商银行", en: "ICBC"}, code: "ICBC" },
    { label: {"zh-CN": "PAB平安银行", en: "PAB"}, code: "PAB" },
    { label: {"zh-CN": "SDB深圳发展银行", en: "SDB"}, code: "SDB" },
    { label: {"zh-CN": "SPDB浦发银行", en: "SPDB"}, code: "SPDB" },
  ];
}

//证件类型
export function getCardType(code) {
  let cardType = [
    {
      value: "0",
      label: {"en": "ID Card", "zh-CN": "身份证"},
      code: "icNo",
      pattern: /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/,
    },
    {
      value: "1",
      label: {"en": "Passport", "zh-CN": "护照"},
      code: "pass",
      pattern: /^[a-zA-Z0-9]{5,17}$/,
    },
    {
      value: "2",
      label: {"en": "Officers card", "zh-CN": "军官证"},
      code: "officer",
      pattern: /^[a-zA-Z0-9]{7,21}$/,
    },
    {
      value: "3",
      label: {"en": "Sergeant certificate", "zh-CN": "士兵证"},
      code: "sergeant",
      pattern: /^[a-zA-Z0-9]{7,21}$/,
    },
    {
      value: "4",
      label: {"en": "Permit", "zh-CN": "港澳台通行证"},
      code: "permit",
      pattern: /^[a-zA-Z0-9]{5,21}$/,
    },
    {
      value: "5",
      label: {"en": "Temporary ID Card", "zh-CN": "临时身份证"},
      code: "tempIcNo",
      pattern: /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/,
    },
    {
      value: "6",
      label: {"en": "Household register", "zh-CN": "户口本"},
      code: "house",
      pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
    },
    {
      value: "9",
      label: {"en": "Police officer card", "zh-CN": "警官证"},
      code: "police",
      pattern: /^[a-zA-Z0-9]{7,21}$/,
    },
    {
      value: "12",
      label: {"en": "Alien Residence Permit", "zh-CN": "外国人居留证"},
      code: "alien",
      pattern: /^[A-Z]{3}\d{6}(?:0[1-9]|1[021])(?:0[1-9]|[21]\d|3[10])\d{2}$/,
    },
    {
      value: "15",
      label: {"en": "Return Permit", "zh-CN": "回乡证"},
      code: "return",
      pattern: /(H|M)(\d{10})$/,
    },
    {
      value: "16",
      label: {"en": "Enterprise business license", "zh-CN": "企业营业执照"},
      code: "enter",
      pattern: /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/,
    },
    {
      value: "17",
      label: {"en": "Legal person code certificate", "zh-CN": "法人代码证"},
      code: "legal",
      pattern: /^[a-zA-Z0-9]{8}-[a-zA-Z0-9]$/,
    },
    {
      value: "18",
      label: {"en": "Taiwan compatriot syndrome", "zh-CN": "台胞证"},
      code: "taiwan",
      pattern: /(^\d{8})$/,
    },
    {
      value: "7",
      label: {"en": "Other types of certificates", "zh-CN": "其他类型证件"},
      code: "other",
    },
  ];
  if (code) {
    let cardItem = cardType.find((item) => {
      if (item.code === code) {
        return item;
      }
    });
    if (cardItem) {
      return cardItem.value;
    } else {
      return "";
    }
  } else {
    return cardType;
  }
}

//币种
export function getCurrencyList() {
  return ["USD", "EUR", "CNY"];
}

//是否是港澳台
export function isCityGAT(provinceCode) {
  if(provinceCode && (provinceCode.startsWith("810") || provinceCode.startsWith("710") || provinceCode.startsWith("820"))){
    return true;
  } else {
    return false;
  }
}

//是否有效邮箱
export function isEmail(value) {
  if(value === '') {
    return false;
  } else {
    if (value !== '') { 
      var reg=/^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      if(!reg.test(value)){
        return false;
      }
      else{
        return true;
      }
    }
  }
}

export function _debounce(fn, delay = 300) {
  var timer = null;
    return function () {
    var _this = this;
    var args = arguments;
    if (timer) clearTimeout(timer); 
    timer = setTimeout(function () {
      fn.apply(_this, args);
    }, delay);
  };
}
export const eval2 = (fn) => {
  var Fun = Function; // 一个变量指向Function，防止有些前端编译工具报错
  return new Fun("return " + fn)();
};
export function base64ToBlob(base64Data, contentType) {
  contentType = contentType || '';
  const sliceSize = 1024;
  const byteCharacters = window.atob(base64Data);
  const bytesLength = byteCharacters.length;
  const slicesCount = Math.ceil(bytesLength / sliceSize);
  const byteArrays = new Array(slicesCount);

  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize;
    const end = Math.min(begin + sliceSize, bytesLength);

    const bytes = new Array(end - begin);
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }

  return new Blob(byteArrays, {
    type: contentType
  });
};
export function debounce(fn, delay) {
  let timer = null;
  return function(...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}